// extracted by mini-css-extract-plugin
module.exports = {"nav__links":"nav__links__3I-Cb","fadeIn":"fadeIn__2aJ5v","fadeOut":"fadeOut__3JXQy"};